import React from "react";
import {useSelector} from "react-redux";
import {RootState} from "../../redux/store";

const CheckboxChecked: React.FC = () => {
    const {brandText} = useSelector((state: RootState) => state?.branding);
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill={brandText} xmlns="http://www.w3.org/2000/svg">
            <rect x="1" y="1" width="21" height="21" rx="1.5" stroke={brandText}/>
        </svg>
    );
};
export default CheckboxChecked;

